import { CircleConfig, CircleStyle } from '../../../models/internal_api/circleInterfaces.model';
import './DataCircle.scss';

export default function DataCircle(circleConfig: CircleConfig) {
    const circleStyle: CircleStyle = {
        width: circleConfig.circleData.size,
        height: circleConfig.circleData.size,
        backgroundColor: circleConfig.filled ? `rgba(${circleConfig.circleData.color}, 0.9)` : `transparent`,
        outline: circleConfig.filled ? `6px solid rgba(${circleConfig.circleData.color}, 0.2)` : 'none',
        border: circleConfig.filled ? 'none' : `4px solid rgba(${circleConfig.circleData.color}, 0.2)`,
    };

    const circleHeaderClassName: string = `DataCircle__value--${circleConfig.filled ? 'filled' : 'transparent'}`;
    const circleTextClassName: string = `DataCircle__text--${circleConfig.filled ? 'filled' : 'transparent'}`;

    return (
        <div className='DataCircle'>
            <div className='DataCircle__container'>
                <div className='DataCircle__circle' style={circleStyle}>
                    <h1 className={circleHeaderClassName} style={circleConfig.headerStyle}>{circleConfig.circleData.value}</h1>
                    <h3 className={circleTextClassName} style={circleConfig.textStyle}>{circleConfig.circleData.text}</h3>
                </div>
            </div>
        </div>
    );
}